import { useQuery } from '@tanstack/react-query';

import API from '@api/API';

export interface UserPayoutRequest {
  userId: string;
  user: {
    _id: string;
    email: string;
    name?: string;
  };
  entertainer?: {
    _id: string;
    userId: string;
    title?: string;
    contact?: { venmo?: string };
  };
  walletLedger: {
    _id: string;
    type: 'withdrawal' | 'deposit';
    amount: number;
    createdAt: string;
    userId: string;
  }[];
}

export const useUserPayoutRequestsQuery = () => {
  const { isFetched, data, refetch } = useQuery({
    queryKey: useUserPayoutRequestsQuery.queryKey(),
    queryFn: () =>
      API.get<{ userPayoutRequests: UserPayoutRequest[] }>('/v1/super-admin/user-payout-requests'),
  });

  return {
    userPayoutRequestsAreReady: isFetched,
    userPayoutRequests: data?.userPayoutRequests,
    refetchUserPayoutRequests: refetch,
  };
};
useUserPayoutRequestsQuery.queryKey = () => ['userPayoutRequests'];
